import Pipeline from '../../../../../../Src/Modules/Pipeline/Pipeline';
import ResolveAdditionalEmailAction from './Actions/ResolveAdditionalEmailAction';
import ResolvePhoneAction from './Actions/ResolvePhoneAction';
import { pick } from 'lodash/object';
import ResolveRegionAction from './Actions/ResolveRegionAction';
import ResolveBloodDonorStatusAction from './Actions/ResolveBloodDonorStatusAction';
import ResolvePlasmaBloodDonorStatusAction from './Actions/ResolvePlasmaBloodDonorStatusAction';
import ResolveAssociationMembershipTypeAction from './Actions/ResolveAssociationMembershipTypeAction';
import ResolveImagesBloodDonationsIdsAction from './Actions/Uploads/ResolveImagesBloodDonationsIdsAction';
import { cloneDeep } from 'lodash/lang';
import ResolveMembershipCardImageAction from './Actions/Uploads/ResolveMembershipCardImageAction';
import ResolvePlasmaDonorStampsAction from './Actions/Uploads/ResolvePlasmaDonorStampsAction';
import ResolveImageForMembershipCardAction from './Actions/Uploads/ResolveImageForMembershipCardAction';
import ResolveBloodDonorInOtherCountryAction from './Actions/ResolveBloodDonorInOtherCountryAction';
import ResolveMembershipTypeAction from './Actions/ResolveMembershipTypeAction';
import ResolveMembershipFeeImageAction from './Actions/Uploads/ResolveMembershipFeeImageAction';
import ResolveAlreadyAssociationMemberImagesAction from './Actions/Uploads/ResolveAlreadyAssociationMemberImagesAction';
import ResolveAlreadyAssociationMemberAction from './Actions/ResolveAlreadyAssociationMemberAction';
import ResolveBirthdateAction from './Actions/ResolveBirthdateAction';

export default (bloodDonorModel) => {
    const model = (new Pipeline())
        .send(cloneDeep(bloodDonorModel))
        .through([
            // general data actions
            ResolveAdditionalEmailAction,
            ResolveBirthdateAction,
            ResolvePhoneAction,
            ResolveRegionAction,
            ResolveBloodDonorStatusAction,
            ResolvePlasmaBloodDonorStatusAction,
            ResolveMembershipTypeAction,
            ResolveAssociationMembershipTypeAction,
            ResolveBloodDonorInOtherCountryAction,
            ResolveAlreadyAssociationMemberAction,

            // upload data actions
            ResolveImageForMembershipCardAction,
            ResolveImagesBloodDonationsIdsAction,
            ResolveMembershipCardImageAction,
            ResolvePlasmaDonorStampsAction,
            ResolveMembershipFeeImageAction,
            ResolveAlreadyAssociationMemberImagesAction,
        ])
        .thenReturn();

    return pick(
        model,
        [
            'bloodDonorStatus',
            'plasmaBloodDonorStatus',
            'membershipType',
            'associationMembershipType',

            'firstname',
            'lastname',
            'email',
            'additional_emails',
            'phone',
            'birthdate',
            'password',
            'employment_status',
            'shirt_size',

            'region',
            'municipality',
            'residence_place',
            'address',

            'klasa',
            'blood_donation_id',
            'blood_donation_count',
            'blood_donation_stamps_count',
            'blood_donor_in_other_country',
            'blood_donor_other_country_name',

            'member_id',
            'rfid_number',

            'zero_fifty',
            'function',

            'already_association_member',
            'already_association_member_images',

            'membershipColor',

            'images_blood_donation_ids',
            'membership_card_image',
            'image_for_membership_card',
            'plasma_donor_stamps',
            'membership_fee_image',
        ]
    );
}